<template>
  <div class='operating-recode-component'>
    <div class='search-component box'>
      <div class='search-warp'>
        <div class='control'>
          <label for="type">类型：</label>
              <el-select v-model="search.type"  @change='selectType'>
                 <el-option
                   v-for="item in AccountOptions"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
                  </el-option>
              </el-select>
        </div>
        <div class="control">
          <label for="account">账号：</label>
          <span style="display:inline-block">
            <el-select v-model="search.accountId" @change="vSelectChange" placeholder="请选择">
                 <el-option
                   v-for="item in operatorList"
                   :key="item.userId"
                   :label="item.username"
                   :value="item.userId">
                  </el-option>
              </el-select>
          </span>
        </div>
        <div class='control'>
          <label for="account">动态ID：</label>
          <input type="text" class='input width-2' v-model='search.articleId'>
        </div>
        <div class='control'>
          <label for="desc">操作描述：</label>
            <el-select v-model="search.opType" >
                 <el-option
                   v-for="item in operation"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
                  </el-option>
              </el-select>
        </div>
      </div>
      <div class="search-wrap">
        <div class="control">
          <label for="time">操作时间：</label>
          <el-date-picker
            v-model="time"
            type="datetimerange"
            @change="changeTime"
            placeholder="选择时间范围">
          </el-date-picker>
        </div>
        <div class="control">
          <button class='button is-info' @click='searchClick'>搜索</button>
        </div>
      </div>
    </div>
    <div class="table-wrap">
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <table class="table is-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>账号</th>
            <th>备注</th>
            <th>操作动态ID</th>
            <th>操作描述</th>
            <th>操作时间</th>
            <th>类型</th>
          </tr>
        </thead>
        <tbody>
          <tr class="list-cell" v-for="(item,index) in list">
            <td>{{item.accountId}}</td>
            <td>{{item.accountName}}</td>
            <td>{{item.remark}}</td>
            <td>{{item.articleId}}</td>
            <td>{{getOpType(item.opType)}}</td>
            <td>{{item.opTime}}</td>
            <td>{{getType(item.type)}}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  export default {
    data() {
      return {
        AccountOptions: [{
          value: -1,
          label: '全部'
        }, {
          value: 2,
          label: '特殊账号'
        }, {
          value: 1,
          label: '后台操作'
        }, {
          value: 0,
          label: '系统'
        }],
        operation:[{
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '撤回'
        }, {
          value: 1,
          label: '放行'
        }, {
          value: 2,
          label: '编辑'
        }, {
          value: 3,
          label: '删除'
        }, {
          value: 4,
          label: '恢复'
        },],
        time:'',// 时间范围
        selectValue:"-1",
        search: {
          type: -1,
          accountId: -1,
          articleId: '',
          opType: -1,
          startTime: '',
          endTime: '',
          page: 1,
          pageSize: 10
        },
        searchAccount: {},
        list: [],
        operator: {
          admin: [],
          special: [],
          system: [],
          all:[],
        },
        operatorList: [],
        count: 0
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        if (this.$route.query.articleId) {
          this.search.articleId = this.$route.query.articleId
        }
        this.getOpRecordList()
        this.getOperatorList()
      })
    },
    methods: {
      changeTime(){
        this.search.startTime=this.time[0];
        this.search.endTime=this.time[1];
      },
      handleCurrentChange(page){
        if(this.search.page!==page){
          this.search.page=page;
          this.getOpRecordList();
        }
      },
      vSelectChange(data) {
        this.search.accountId = data
      },
      searchClick() {
        this.search.page = 1;
        this.getOpRecordList()
      },
      getOpRecordList() {
        HttpRequest.get('/admin.php?method=fashion.getOpRecordList',this.search).then(response => {
          if (response && response.data) {
            this.count = JSON.parse(response.data.count)
            this.list = _.toArray(response.data.list);
          }
        })
      },
      getOperatorList() {
        HttpRequest.get('/admin.php?method=fashion.getOperatorList').then(response => {
          this.operator.admin = response.data.admin ? response.data.admin : this.operator.admin
          this.operator.special = response.data.special ? response.data.special : this.operator.special
          this.operator.system = response.data.system ? response.data.system : this.operator.system;
          this.operator.all=this.operator.admin.concat(this.operator.special).concat(this.operator.system);
          this.operatorList.unshift({userId: -1, username: "全部"})
        })
      },
      selectType() {
        this.operatorList = []
        switch(parseInt(this.search.type)) {
          case 0:
            this.operatorList = JSON.parse(JSON.stringify(this.operator.system))
            break
          case 1:
            this.operatorList = JSON.parse(JSON.stringify(this.operator.admin))
            break
          case 2:
            this.operatorList = JSON.parse(JSON.stringify(this.operator.special))
            break
        }
        this.operatorList.unshift({userId: -1, username: "全部"})
      },
      getOpType(opType) {
        switch(opType) {
          case 0:
            return '撤回'
          case 1:
            return '放行'
          case 2:
            return '编辑'
          case 3:
            return '删除'
          case 4:
           return '恢复'
        }
      },
      getType(type) {
        switch(type) {
          case 0:
            return '系统'
          case 1:
            return '后台操作'
          case 2:
            return '特殊账号'
        }
      }
    }
  }
</script>
